import { createFileRoute } from '@tanstack/react-router';

import { AccountPage } from '@/features/account/AccountPage';

/** `/account` —— 帳號設定（基本資料、密碼、刪除帳號）。未登入時頁面自己畫登入提示。 */
export const Route = createFileRoute('/account')({
  component: AccountPage,
});
